export enum TouchpointType {
  LINK = 'link',
  URL = 'url',
  ROOT = 'root',
}
